module.exports = __webpack_public_path__ + "static/media/06_Mascotte_glacial.57d2b640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/06_Mascotte_glacial.svg
// module id = 762
// module chunks = 0